var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 11.5,
    fill: "#FAF0CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0L17.5689 5.76645L21.8044 1.34004L21.3491 7.44947L27.0187 5.12848L24.1178 10.5245L30.2414 10.7102L25.3965 14.4598L30.9151 17.1202L24.964 18.575L28.9234 23.25L22.895 22.1585L24.6107 28.0398L19.5474 24.5907L18.7226 30.6613L15.5 25.451L12.2774 30.6613L11.4526 24.5907L6.38933 28.0398L8.10497 22.1585L2.07661 23.25L6.03604 18.575L0.0849104 17.1202L5.60351 14.4598L0.758624 10.7102L6.88218 10.5245L3.98126 5.12848L9.65095 7.44947L9.19558 1.34004L13.4311 5.76645L15.5 0Z",
    fill: "#F4D35E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/lightMode.6654eb45531cd4bf4f5b99d218c11f9e.svg";
export { ForwardRef as ReactComponent };